jQuery(document).ready(function($) {
    $('#password-reset-form').submit(function(event) {
        event.preventDefault();
        var userEmail = $('#user_email').val(); // Отримуємо значення з поля електронної пошти
        var emailInput = $('#user_email');

        var isFormValid = true;
        var errorMessage = '';
        // Перевіряємо заповненість полів
        if (!userEmail) {

            errorMessage = localized_texts.enter_fields;
            displayNotification(errorMessage, false, 3);
            removeErrorClass();
            emailInput.addClass('error');
            isFormValid = false
        }
        if (isFormValid) {
            $.ajax({
                type: 'POST',
                url: ajax_reset.ajax_url, // URL адреса для AJAX запиту
                data: {
                    action: 'custom_password_reset', // Дія для обробки на сервері
                    user_email: userEmail, // Передаємо значення електронної пошти
                },
                success: function (response) {
                    var jsonResponse = JSON.parse(response);
                    if (jsonResponse.success){
                        removeErrorClass();
                        displayNotification(jsonResponse.message, jsonResponse.success, 3);
                        setTimeout(function() { // Додаємо затримку перед оновленням HTML
                            $('#recovery-pass').removeClass('open');
                        }, 3100); // Затримка 3.1 секунди
                    } else{
                        displayNotification(jsonResponse.message, jsonResponse.success, 3);
                        if (jsonResponse.field) {
                            removeErrorClass();
                            $('#' + jsonResponse.field).addClass('error');
                        }
                    }
                }
            });
        }
    });
    function displayNotification(message, isSuccess, durationInSeconds = 15) {
        var notificationElement = $('.modal_notification');
        notificationElement.text(message).addClass('visible');
        if (!isSuccess) {
            notificationElement.addClass('error');
        } else {
            notificationElement.removeClass('error').addClass('success');
        }
        setTimeout(function() {
            notificationElement.removeClass('visible error success');
        }, durationInSeconds * 1000); // 15 секунд
    }

    function removeErrorClass() {
        var errorElement = document.querySelectorAll('.modal_form .error'); // Отримуємо всі елементи введення з класом помилки
        errorElement.forEach(function(input) { // Ітеруємося по кожному елементу
            input.classList.remove('error'); // Видаляємо клас помилки
        });
    }
});


